import { Component } from '@angular/core';

@Component({
  selector: 'app-historical-nav',
  templateUrl: './historical-nav.component.html',
  styleUrls: ['./historical-nav.component.css']
})
export class HistoricalNavComponent {

}
